module.exports = __webpack_public_path__ + "Icon_System Settings.03ba9df0cffdfe11863d.png";